import './_thermometers-view.sass';

import $ from 'jquery';

import React from 'react';

import Class from '../../legacy-class';

import {subscribeToDevice} from './subscripbe-to-device';
import {rf_color, rf_title_by_type, show_temp_for_rf_type} from '../../rf/rf-utils';
import {LegacyDevice} from '../../../../device/device';
import {owaMultiplier} from '../../../../device-settings/owa';
import {currentServerUnixTime} from '../../../../../utils/time';
import {Thermometer} from './thermometer-component';
import {createRoot} from 'react-dom/client';
import {ThermometerState} from '../../../../../utils/thermometers';
import {owaAxis} from '../../../graphs/components/graph/utils/owa-axes';

const _oldColors = {
    blue: '#2ababe',
    red: '#ff0016',
    green: '#a6d000',
    yellow: '#f0c030',
};

export const ThermometersView_NonReact = Class({
    init() {
        this._element = $('<div></div>');
    },

    element() {
        return this._element;
    },

    _recreate_control() {
        const root = createRoot(this._element.get(0));

        if (this._device)
            root.render(
                <SubscribedThermometersView
                    current_server_time_func={this._device.current_server_time.bind(
                        this._device
                    )}
                    device={this._device}
                />
            );
        else root.unmount(this._element.get(0));
    },
}).implement(
    Class.Properties({
        device: {
            set(value) {
                if (value === this._device) return;
                this._device = value;
                this._recreate_control();
            },
        },
    })
);

export const ThermometersView = ({
    micro = false,
    active_thermometers,
    thermometers_reset_in_progress,
    rf_status,
    online,
    current_server_time_func,
    internet_weather,
    use_internet_weather_for_pza,
    pza,
}) => {
    const rf_malfunction_time = 60 * 60;

    const wired_therms = active_thermometers.map((therminfo) => {
        const owa_m = owaMultiplier(therminfo);
        let limits = therminfo.limits;

        if (limits != null && owa_m !== 1) {
            limits = {
                ...limits,
                low: limits.low * owa_m,
                high: limits.high * owa_m,
            };
        }

        return (
            <Thermometer
                limits={limits}
                key={therminfo.serial}
                micro={micro}
                // type={therminfo.type}
                axis_key={owaAxis(therminfo.serial) ?? 'temperature'}
                name={therminfo.name ?? `Датчик №${therminfo.slot}`}
                color={_oldColors[therminfo.color] ?? therminfo.color}
                state={
                    therminfo.last_state === 'not_connected'
                        ? ThermometerState.not_connected
                        : therminfo.last_state === 'malfunction'
                        ? ThermometerState.malfunction
                        : therminfo.last_state === 'ok'
                        ? ThermometerState.ok
                        : null
                }
                value={therminfo.last_value * owa_m}
                rf={rf_status?.[therminfo.serial]}
            />
        );
    });

    const therm_serials = active_thermometers.map((therminfo) => therminfo.serial);

    const current_server_time = current_server_time_func();
    const rf_therms = Object.entries(rf_status ?? {})
        .filter(([serial, _rf_props]) => !therm_serials.includes(serial))
        .filter(([_serial, rf_props]) => show_temp_for_rf_type(rf_props.type))
        .map(([serial, rf_props]) => (
            <Thermometer
                key={serial}
                micro={micro}
                // type='radio'
                axis_key="temperature"
                name={rf_props.name ?? rf_title_by_type(rf_props.type, rf_props.slot)}
                color={rf_color(serial)}
                state={
                    !online || rf_props.time > current_server_time - rf_malfunction_time
                        ? ThermometerState.ok
                        : ThermometerState.malfunction
                }
                value={rf_props.temp}
                rf={rf_props}
            />
        ));

    const therms = [...wired_therms, ...rf_therms];

    if (internet_weather != null && use_internet_weather_for_pza && pza?.enabled) {
        therms.push(
            <Thermometer
                key="internet_weather"
                micro={micro}
                // type='internet_weather'
                axis_key="temperature"
                name="погода"
                color="#ff9100"
                state={ThermometerState.ok}
                value={internet_weather}
            />
        );
    }

    return (
        <div className="ui-thermometers-view-therms-container">
            {thermometers_reset_in_progress ? (
                <div className="ui-thermometers-view-therms-empty">
                    <p>Произведён сброс термодатчиков</p>
                    <p>
                        Устройство обнаружит подключенные датчики в течение нескольких
                        минут
                    </p>
                </div>
            ) : therms.length > 0 ? (
                therms
            ) : (
                <div className="ui-thermometers-view-therms-empty">
                    Подключите термодатчик к устройству
                </div>
            )}
        </div>
    );
};

export const SubscribedThermometersView = subscribeToDevice(ThermometersView, [
    'thermometers',
    'active_thermometers',
    'thermometers_reset_in_progress',
    'rf_status',
    'online',

    'stationary_location',
    'internet_weather',
    'use_internet_weather_for_pza',
    'pza',
]);

export const DeviceThermometersView = ({r_device, server_time, micro = false}) => (
    <ThermometersView
        micro={micro}
        thermometers={r_device.thermometers}
        active_thermometers={LegacyDevice.active_thermometers(r_device?.thermometers)}
        rf_status={r_device.rf_status}
        thermometers_reset_in_progress={false} // FIXME: not working for now
        online={r_device.online}
        current_server_time_func={() => currentServerUnixTime(server_time)}
        stationary_location={r_device.stationary_location}
        internet_weather={r_device.internet_weather}
        use_internet_weather_for_pza={r_device.use_internet_weather_for_pza}
        pza={r_device.pza}
    />
);
